import { lazy } from 'react';
import ErrorBox from './ErrorBox';
import Location from './Location';
import Blog from './Blog';
import Quotes from './Quotes';
// import winamplify from './winampify';
import Domains from './Domains';
import Pictures from './Pictures';
import Documents from './Documents';
import Explorer from './Explorer';
import error from 'assets/windowsIcons/897(16x16).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import music from 'assets/windowsIcons/music16.png';
import location from 'assets/windowsIcons/299(32x32).png';
import computer from 'assets/windowsIcons/676(32x32).png';
import Resume from './Resume';
import resume from 'assets/windowsIcons/resume32.png';
import quotes from 'assets/windowsIcons/quotes32.png';
import domains from 'assets/windowsIcons/internet-folder-32x32.png';
import picturesIcon from 'assets/windowsIcons/307(32x32).png';
import documentsIcon from 'assets/windowsIcons/308(32x32).png';
import folderIcon from 'assets/icons/folder-32x32.png';

const Winamp = lazy(() => import('./Winamp'));
const MyComputer = lazy(() => import('./MyComputer'));

const gen = () => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
};
const genId = gen();
const genIndex = gen();
export const defaultAppState = [
  {
    component: Blog,
    header: {
      title: 'Food for Thought',
      icon: notepad,
    },
    defaultSize: {
      width: Math.min(900, Math.round(window.innerWidth * 0.52)),
      height: Math.min(700, Math.round(window.innerHeight * 0.6)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(900, Math.round(window.innerWidth * 0.52))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Quotes,
    header: {
      title: 'Quotes',
      icon: quotes,
      noFooterWindow: true,
    },
    defaultSize: {
      width: Math.min(900, Math.round(window.innerWidth * 0.52)),
      height: Math.min(700, Math.round(window.innerHeight * 0.6)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(900, Math.round(window.innerWidth * 0.52))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Domains,
    header: {
      title: 'Domains for Sale',
      icon: quotes,
      noFooterWindow: true,
    },
    defaultSize: {
      width: Math.min(900, Math.round(window.innerWidth * 0.52)),
      height: Math.min(700, Math.round(window.innerHeight * 0.6)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(900, Math.round(window.innerWidth * 0.52))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Location,
    header: {
      title: 'Where Am I?',
      icon: location,
      noFooterWindow: true,
    },
    defaultSize: {
      width: Math.min(640, Math.round(window.innerWidth * 0.45)),
      height: Math.min(360, Math.round(window.innerHeight * 0.35)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(640, Math.round(window.innerWidth * 0.45))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.18),
    },
    resizable: true,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Winamp,
    header: {
      title: 'Playlist',
      icon: music,
    },
    defaultSize: {
      width: 320,
      height: 160,
    },
    defaultOffset: {
      x: window.innerWidth * 0.15,
      y: window.innerHeight * 0.15,
    },
    resizable: true,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: MyComputer,
    header: {
      title: 'My Computer',
      icon: computer,
      noFooterWindow: true,
    },
    defaultSize: {
      width: Math.min(1000, Math.round(window.innerWidth * 0.6)),
      height: Math.min(700, Math.round(window.innerHeight * 0.6)),
    },
    defaultOffset: {
      x: window.innerWidth * 0.25,
      y: window.innerHeight * 0.25,
    },
    resizable: true,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Resume,
    header: {
      title: 'Resume',
      icon: resume,
      noFooterWindow: true,
    },
    defaultSize: {
      width: Math.min(1200, Math.round(window.innerWidth * 0.8)),
      height: Math.min(
        Math.round(window.innerHeight * 0.85),
        Math.round(
          Math.min(1200, Math.round(window.innerWidth * 0.8)) * 0.4314,
        ) + 120,
      ),
    },
    defaultOffset: {
      x: window.innerWidth * 0.25,
      y: window.innerHeight * 0.25,
    },
    resizable: true,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Explorer,
    header: {
      title: 'Explorer',
      icon: folderIcon,
    },
    defaultSize: {
      width: Math.min(1000, Math.round(window.innerWidth * 0.64)),
      height: Math.min(720, Math.round(window.innerHeight * 0.7)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(1000, Math.round(window.innerWidth * 0.64))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: true,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
];

export const defaultIconState = [
  {
    id: 4,
    icon: music,
    title: 'Playlist',
    component: Winamp,
    isFocus: false,
  },
  {
    id: 5,
    icon: domains,
    title: 'Domains for Sale',
    component: Domains,
    isFocus: false,
  },
  {
    id: 3,
    icon: notepadLarge,
    title: 'Food for Thought',
    component: Blog,
    isFocus: false,
  },
  {
    id: 1,
    icon: quotes,
    title: 'Cool Quotes',
    component: Quotes,
    isFocus: false,
  },
  {
    id: 2,
    icon: resume,
    title: 'Resume',
    component: Resume,
    isFocus: false,
  },
  {
    id: 0,
    icon: location,
    title: 'Where am I?',
    component: Location,
    isFocus: false,
  },
  // {
  //   id: 6,
  //   icon: folderIcon,
  //   title: 'Explorer',
  //   component: Explorer,
  //   isFocus: false,
  // },
  // {
  //   id: 7,
  //   icon: picturesIcon,
  //   title: 'My Pictures',
  //   component: Pictures,
  //   isFocus: false,
  // },
  // {
  //   id: 8,
  //   icon: documentsIcon,
  //   title: 'My Documents',
  //   component: Documents,
  //   isFocus: false,
  // },
];

export const appSettings = {
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Blog: {
    header: {
      icon: notepad,
      title: 'Food for Thought',
    },
    component: Blog,
    defaultSize: {
      width: Math.min(900, Math.round(window.innerWidth * 0.52)),
      height: Math.min(700, Math.round(window.innerHeight * 0.6)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(900, Math.round(window.innerWidth * 0.52))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Quotes: {
    header: {
      icon: quotes,
      title: 'Quotes',
    },
    component: Quotes,
    defaultSize: {
      width: Math.min(900, Math.round(window.innerWidth * 0.52)),
      height: Math.min(700, Math.round(window.innerHeight * 0.6)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(900, Math.round(window.innerWidth * 0.52))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Domains: {
    header: {
      icon: quotes,
      title: 'Domains',
    },
    component: Domains,
    defaultSize: {
      width: Math.min(900, Math.round(window.innerWidth * 0.52)),
      height: Math.min(700, Math.round(window.innerHeight * 0.6)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(900, Math.round(window.innerWidth * 0.52))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  MyComputer: {
    header: {
      icon: computer,
      title: 'My Computer',
    },
    component: MyComputer,
    defaultSize: {
      width: Math.min(1000, Math.round(window.innerWidth * 0.6)),
      height: Math.min(700, Math.round(window.innerHeight * 0.6)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(1000, Math.round(window.innerWidth * 0.6))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.15),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Winamp: {
    header: {
      icon: music,
      title: 'UNTDL2',
      invisible: true,
    },
    component: Winamp,
    defaultSize: {
      width: 320,
      height: 160,
    },
    defaultOffset: {
      x: window.innerWidth * 0.15,
      y: window.innerHeight * 0.15,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Pictures: {
    header: { icon: picturesIcon, title: 'My Pictures' },
    component: Pictures,
    defaultSize: {
      width: Math.min(1000, Math.round(window.innerWidth * 0.6)),
      height: Math.min(700, Math.round(window.innerHeight * 0.65)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(1000, Math.round(window.innerWidth * 0.6))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Documents: {
    header: { icon: documentsIcon, title: 'My Documents' },
    component: Documents,
    defaultSize: {
      width: Math.min(1000, Math.round(window.innerWidth * 0.64)),
      height: Math.min(720, Math.round(window.innerHeight * 0.7)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(1000, Math.round(window.innerWidth * 0.64))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.1),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Explorer: {
    header: { icon: folderIcon, title: 'Explorer' },
    component: Explorer,
    defaultSize: {
      width: Math.min(1000, Math.round(window.innerWidth * 0.64)),
      height: Math.min(720, Math.round(window.innerHeight * 0.7)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(1000, Math.round(window.innerWidth * 0.64))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.12),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Location: {
    header: {
      icon: location,
      title: 'Where am I?',
    },
    component: Location,
    defaultSize: {
      width: Math.min(640, Math.round(window.innerWidth * 0.45)),
      height: Math.min(360, Math.round(window.innerHeight * 0.35)),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(640, Math.round(window.innerWidth * 0.45))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.18),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  InternetExplorer: {
    header: {
      icon: resume,
      title: 'Resume',
    },
    component: Resume,
    defaultSize: {
      width: Math.min(1200, Math.round(window.innerWidth * 0.8)),
      height: Math.min(
        Math.round(window.innerHeight * 0.85),
        Math.round(
          Math.min(1200, Math.round(window.innerWidth * 0.8)) * 0.4314,
        ) + 120,
      ),
    },
    defaultOffset: {
      x: Math.round(
        (window.innerWidth -
          Math.min(1200, Math.round(window.innerWidth * 0.8))) /
          2,
      ),
      y: Math.round(window.innerHeight * 0.08),
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
};

export {
  ErrorBox,
  Location,
  Blog,
  Winamp,
  MyComputer,
  Resume,
  Quotes,
  Domains,
};
